function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getWindow } from '@shared/services/window';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { Constants } from '@shared/utils/constants';
import { stringifyError } from '@shared/utils/errorUtils';
import { telemetryPageLoadTime } from '@shared/utils/pltUtils';
import { ensureClientLoggerInitialization, logger } from '@src/logger';
import { getNetworkStats } from '@shared/utils/appUtils';
import { initializeListener } from '@embed/embedMessaging';
import { initBusinessTelemetryClient } from '@shared/hooks/useTelemetry';
export class RootHandler extends React.Component {
    componentDidMount() {
        const { store, landingView, isEmbedded } = this.props;
        telemetryPageLoadTime({
            landingView,
            isEmbedded
        });
        ensureClientLoggerInitialization(store);
        initBusinessTelemetryClient();
        if (isEmbedded) {
            // This will register a listener for the javascript 'message' event that
            // the host window uses to communicate with the iframe
            initializeListener(store.dispatch, store.getState().config.embedHost);
        }
    }
    componentDidCatch(error, errorInfo) {
        this.telemetry(Constants.Telemetry.Action.RootHandler, Constants.Telemetry.ActionModifier.Error, {
            errorInfo: stringifyError(errorInfo),
            error: stringifyError(error)
        });
    }
    static getDerivedStateFromError(error) {
        // The error is logged here for dev mode (with babel) to catch the hydration mismatch stack trace
        console.error('React Error', error);
    }
    telemetry(action, actionModifier, details) {
        const { isEmbedded = false, landingView } = this.props;
        const connection = getNetworkStats();
        const userAgent = navigator.userAgent;
        const payload = {
            page: getWindow().location.href,
            action,
            actionModifier,
            details: JSON.stringify(_object_spread_props(_object_spread({}, details), {
                landingView,
                isEmbedded,
                connection,
                userAgent
            }))
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    flushTelemetry() {
        SpzaInstrumentService.getProvider().probe('flushTelemetryInfo');
    }
    render() {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: this.props.children
        });
    }
}
